import { Grid } from "@mui/material";
import * as React from "react";
import { CheckboxDropdown } from "ui/Scripts/source/components/framework/Dropdown/CheckboxDropdown";
import { TreeCheckboxDropdown } from "ui/Scripts/source/components/framework/Dropdown/TreeCheckboxDropdown";
import { IIdTitle } from "ui/Scripts/source/models/common/idTitle";
import { IIdTitleNode } from "ui/Scripts/source/models/common/idTitleNode";
import { Translations } from "ui/Scripts/source/models/translations";
import { Base } from "../../../../../../../QTeamSystems.QTeamIntra.Ui/Scripts/source/framework/base";
import { AppUtils } from "../../../../framework/appUtils";
import { SaveDataObj } from "../../../../framework/saveData";
import { IListFilterItem } from "../../../../models/common/listFilterItem";
import { DrawerContent } from "../../../framework/Drawer/DrawerContent";
import { FilterButtons } from "../../../framework/Filters/FilterButtons";
import { FilterSearchField } from "../../../framework/Filters/FilterSearchField";
import { FormField } from "../../../../../../../QTeamSystems.QTeamIntra.Ui/Scripts/source/components/framework/FormField";
import { GridRow } from "../../../framework/Grid/GridRow";
import { PageFilterConditionDrawer } from "../../../framework/Page/PageFilterConditionDrawer";
import { IdTitleDropdown } from "ui/Scripts/source/components/framework/Dropdown/IdTitleDropdown";

export interface IRecordPageListFilterDrawerProp {
    open: boolean;
    classes?: string;
    filter: IListFilterItem;
    units: IIdTitleNode[];
    activityFilters: IIdTitle[];
    jobTitles: IIdTitle[];
    employeeTypes: IIdTitle[];
    selectedActivityFilterId: string;
    selectedEmployeeTypeIds: string[];
    selectedJobTitleIds: string[];
    selectedUnitIds: string[];
    canRemoveSharedFilters: boolean;
    onSaveFilter: (saveAs: boolean, onGetGeneralFilter: () => any) => void;
    onRemoveFilter: (filterId: string) => void;
    onOk: (closeDialog: boolean, selectedActivityFilterId: string, selectedEmployeeTypeIds: string[], selectedJobTitleIds: string[], selectedUnitIds: string[]) => any;
    onCancel: () => void;
}

export interface IRecordPageListFilterDrawerState {
    selectedEmployeeTypeIds: string[];
    selectedJobTitleIds: string[];
    selectedUnitIds: string[];
    selectedActivityFilterId: string;
}

export class RecordPageListFilterDrawer extends React.Component<IRecordPageListFilterDrawerProp, IRecordPageListFilterDrawerState> {
    private orgStateHash: string = "";

    getStateFromProps = (props: IRecordPageListFilterDrawerProp): IRecordPageListFilterDrawerState => {
        return {
            selectedActivityFilterId: props.selectedActivityFilterId,
            selectedEmployeeTypeIds: props.selectedEmployeeTypeIds.slice(0),
            selectedJobTitleIds: props.selectedJobTitleIds.slice(0),
            selectedUnitIds: props.selectedUnitIds.slice(0),
        };
    };

    constructor(props: IRecordPageListFilterDrawerProp) {
        super(props);
        this.state = this.getStateFromProps(props);
        this.orgStateHash = this.getSaveDataFromState(props, this.state).hash;
    }

    componentDidUpdate(prevProps: IRecordPageListFilterDrawerProp, prevState: IRecordPageListFilterDrawerState): void {
        const props = this.props;
        if (!prevProps ||
            (prevProps.filter?.getHash() === props.filter?.getHash() &&
            prevProps.selectedActivityFilterId === props.selectedActivityFilterId &&
            Base.equalStrArrays(prevProps.selectedEmployeeTypeIds, props.selectedEmployeeTypeIds) &&
            Base.equalStrArrays(prevProps.selectedJobTitleIds, props.selectedJobTitleIds) &&
            Base.equalStrArrays(prevProps.selectedUnitIds, props.selectedUnitIds))) return;
        const state = this.getStateFromProps(props);
        this.setState(state);
        this.orgStateHash = this.getSaveDataFromState(props, state).hash;
    }

    handleChangeUnitIds = (selectedUnitIds: string[]) => {
        this.setState({
            selectedUnitIds
        });
    };

    handleChangeEmployeeTypeIds = (selectedEmployeeTypeIds: string[]) => {
        this.setState({
            selectedEmployeeTypeIds
        });
    };

    handleChangeJobTitleIds = (selectedJobTitleIds: string[]) => {
        this.setState({
            selectedJobTitleIds
        });
    };

    getSaveDataFromState = (props: IRecordPageListFilterDrawerProp, state: IRecordPageListFilterDrawerState): SaveDataObj => {
        const result = new SaveDataObj();
        result.append("selectedActivityFilterId", state.selectedActivityFilterId ? state.selectedActivityFilterId : null);
        result.append("selectedEmployeeTypeIds", state.selectedEmployeeTypeIds);
        result.append("selectedUnitIds", state.selectedUnitIds);
        result.append("selectedJobTitleIds", state.selectedJobTitleIds);
        return result;
    };

    static filterIsSet = (activityFilters: IIdTitle[], employeeTypes: IIdTitle[], jobTitles: IIdTitle[], units: IIdTitleNode[],
        selectedActivityFilterId: string, selectedEmployeeTypeIds: string[], selectedJobTitleIds: string[], selectedUnitIds: string[]): boolean => {
        return !(selectedActivityFilterId === activityFilters[1].id &&
            Base.equalStrArrays(selectedEmployeeTypeIds, [employeeTypes[0].id]) &&
            Base.equalStrArrays(selectedJobTitleIds, [jobTitles[0].id]) &&
            Base.equalStrArrays(selectedUnitIds, [units[0].id]));
    };

    handleSaveFilter = async (saveAs: boolean) => {
        const props = this.props;
        const state = this.state;
        if (!saveAs) {
            props.onOk(false, state.selectedActivityFilterId, state.selectedEmployeeTypeIds, state.selectedJobTitleIds, state.selectedUnitIds);
            await this.props.onSaveFilter(false, null);
        } else {
            await this.props.onSaveFilter(true, () => {
                return props.onOk(false, state.selectedActivityFilterId, state.selectedEmployeeTypeIds, state.selectedJobTitleIds, state.selectedUnitIds);
            });
        }
    };

    handleClear = () => {
        const props = this.props;
        this.setState({
            selectedActivityFilterId: props.activityFilters[1].id,
            selectedEmployeeTypeIds: [props.employeeTypes[0].id],
            selectedJobTitleIds: [props.jobTitles[0].id],
            selectedUnitIds: [props.units[0].id]
        });
    };

    handleSave = async () => {
        const props = this.props;
        const state = this.state;
        props.onOk(true, state.selectedActivityFilterId, state.selectedEmployeeTypeIds, state.selectedJobTitleIds, state.selectedUnitIds);
    };

    handleCancel = async (checkChanges: boolean) => {
        AppUtils.cancelEditDialog(checkChanges, this.getSaveDataFromState(this.props, this.state).hash, this.orgStateHash, this.handleSave, this.props.onCancel, Translations.YouHaveUnapprovedChangesDoYouWantApproveChanges);
    };

    render() {
        const props = this.props;
        const state = this.state;
        return (
            <PageFilterConditionDrawer
                open={props.open}
                onClose={() => this.handleCancel(false)}
            >
                <DrawerContent
                    content={
                        <>
                            <FilterSearchField
                                filter={props.filter}
                                canRemoveSharedFilters={props.canRemoveSharedFilters}
                                onSaveFilter={this.handleSaveFilter}
                                onRemoveFilter={props.onRemoveFilter}
                            />
                            <GridRow>
                                <Grid item sm={12}>
                                    <FormField title={Translations.Card}>
                                        <IdTitleDropdown
                                            selectedId={state.selectedActivityFilterId}
                                            items={props.activityFilters}
                                            onChange={(selectedActivityFilterId) => {
                                                this.setState({ selectedActivityFilterId });
                                            }}
                                        />
                                    </FormField>
                                </Grid>
                            </GridRow>
                            <GridRow>
                                <Grid item sm={12}>
                                    <FormField title={Translations.Unit}>
                                        <TreeCheckboxDropdown
                                            required={true}
                                            selectedIds={state.selectedUnitIds}
                                            values={props.units}
                                            onChange={this.handleChangeUnitIds}
                                        />
                                    </FormField>
                                </Grid>
                            </GridRow>
                            <GridRow>
                                <Grid item sm={12}>
                                    <FormField title={Translations.EmployeeType}>
                                        <CheckboxDropdown
                                            required={true}
                                            selectedIds={state.selectedEmployeeTypeIds}
                                            toggleAll={true}
                                            values={props.employeeTypes}
                                            onChange={this.handleChangeEmployeeTypeIds}
                                        />
                                    </FormField>
                                </Grid>
                            </GridRow>
                            <GridRow>
                                <Grid item sm={12}>
                                    <FormField title={Translations.JobTitle}>
                                        <CheckboxDropdown
                                            required={true}
                                            toggleAll={true}
                                            selectedIds={state.selectedJobTitleIds}
                                            values={props.jobTitles}
                                            onChange={this.handleChangeJobTitleIds}
                                        />
                                    </FormField>
                                </Grid>
                            </GridRow>
                        </>
                    }
                    actions={
                        <FilterButtons
                            onSave={this.handleSave}
                            onCancel={() => this.handleCancel(false)}
                            onClear={this.handleClear}
                        />
                    }
                />
            </PageFilterConditionDrawer>
        );
    }
}